import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export const ProductStoreModel = {
  code: '',
  name: '',
  units: 'buc',
  buyPrice: 0,
  sellPrice: 0,
};

export default {
  namespaced: true,
  state: {
    product: { ...ProductStoreModel },
    products: [],
  },
  mutations: {
    updateOne(state, product) {
      state.product = product;
    },
    updateAll(state, products) {
      state.products = products;
    },
    add(state, product) {
      state.products.push(product);
      state.product = { ...ProductStoreModel };
    },
    modify(state, product) {
      state.products = state.products.map((value) => (product.id === value.id ? product : value));
      state.product = { ...ProductStoreModel };
    },
    delete(state, id) {
      state.products = state.products.filter((product) => product.id !== id);
    },
  },
  actions: {

    async getProduct({ commit }, id) {
      axiosInstance.get(urlsAPI.productsURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateOne', response.data);
          }
        })
        .catch(handlerError);
    },

    async getProducts({ commit }) {
      axiosInstance.get(urlsAPI.productsURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateAll', response.data);
          }
        })
        .catch(handlerError);
    },

    async create({ commit, state }) {
      return axiosInstance.post(urlsAPI.productsURL, state.product)
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          commit('add', response.data);
          return response.data;
        })
        .catch(handlerError);
    },

    async update({ commit, state }, id) {
      return axiosInstance.put(urlsAPI.productsURL + id, state.product)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('modify', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, id) {
      return axiosInstance.delete(urlsAPI.productsURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('delete', id);
          }
        })
        .catch(handlerError);
    },

  },
};
